<template>
	<tr>
		<td class="text-center vertical-center">{{ index + 1 }}.</td>
		<td class="align-items-center vertical-center">
			<div class="">
				<div class="text-bold">#{{ order.reference_id }}</div>
			</div>
		</td>
		<td class="vertical-center">
			<div v-if="order.type === 'storefront'"
				class="product-image"
				:style="{
					backgroundImage: `url(${
						order.products[0].picture && order.products[0].picture !== ''
							? order.products[0].picture
							: 'https://cdn.ostock.id/img/default-product.png'
					})`,
				}"
			></div>
			<div v-if="order.type === 'form'"
				class="product-image"
				:style="{
					backgroundImage: `url(${
						order.product_picture && order.product_picture !== ''
							? order.product_picture
							: 'https://cdn.ostock.id/img/default-product.png'
					})`,
				}"
			></div>
		</td>
		<td class="vertical-center">
			<div class="submission-product-name" v-if="order.type === 'form'" v-tooltip="order.product_name">
				{{ order.product_name }}
			</div>
			<div v-else-if="order.cart_items" class="d-inline">
				<div
					class="mb-2"
					v-for="(cartItem, index) in order.cart_items"
					:key="index"
				>
					{{ cartItem.product_name }} (x{{ cartItem.qty }})
				</div>
			</div>
		</td>
		<td class="vertical-center">
			<div class="submission-variations" v-if="order.customer_data">
				<template v-if="order.type === 'form'">
					<div
						class="d-flex flex-column"
						v-if="order.customer_data.variations &&
						order.customer_data.variations.length > 0"
					>
						<span class="mb-2"
							v-for="(itemVar, varIndex) in customerDataVariations(
								order.customer_data.variations,
								true,
							)"
							:key="varIndex"
							>{{ itemVar.name }} (x{{ itemVar.quantity }}
						)</span
						>
					</div>
					<div class="d-flex flex-column" v-else-if="order.customer_data.variation && order.customer_data.variation !== ''">
						<span class="mb-2" v-for="(itemVar, varIndex) in customerDataVariations(order.customer_data.variation,false,)" :key="varIndex">
							{{ itemVar }}
						</span>
					</div>
				</template>
			<order-items :items="order.cart_items" v-else> </order-items>
			</div>
		</td>
		<td class="vertical-center">
			<div class="submission-quantity">
			{{ getQuantity(order) }}
			</div>
		</td>
		<td class="vertical-center">
			<mark :class="`order-status status-${getOrderDisplayStatus(order).style}`">
				<span>{{ getOrderDisplayStatus(order).label }}</span>
			</mark>
		</td>
		<td class="text-right vertical-center">
			{{ formatMoney(order.net_revenue) }}
		</td>
		<td class="text-center vertical-center">
			<div class="order-date">{{ formatDate(order.ordered_at) }}</div>
		</td>
		<td class="vertical-center">
			<div>
				{{ order.supplier_name }} ({{ order.supplier_username || '-' }})
			</div>
			<div>
				<a
					:href="`https://wa.me/62${validatePhoneNumber(order.supplier_phone)}`"
					target="_blank"
				>
					+62{{ validatePhoneNumber(order.supplier_phone) }}
				</a>
			</div>
		</td>
		<td class="vertical-center">
			<div>{{ order.seller_name }} ({{ order.seller_username || '-' }})</div>
			<div>
				<a
					:href="`https://wa.me/62${validatePhoneNumber(order.seller_phone)}`"
					target="_blank"
				>
					+62{{ validatePhoneNumber(order.seller_phone) }}
				</a>
			</div>
		</td>
		<td class="vertical-center">
			<div class="shipment-address" v-if="order.customer_data">
			<span>{{ order.customer_data.province_name }}, </span>
			<span>{{ order.customer_data.city_name }}, </span>
			<span>{{ order.customer_data.subdistrict_name }}, </span>
			<span>{{ order.customer_data.address }} </span>
			</div>
		</td>
	</tr>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	copyToClipboard,
	generateVariationsData,
	// getAxiosErrorMessage,
	getOrderDisplayStatus,
	validatePhoneNumber,
} from '@/lib/helper';
// import adminApi from '@/api/admin';
import OrderItems from '@/components/OrderItems.vue';

export default {
	name: 'LeadsOrderSearchRow',
	components: {
		OrderItems,
	},
	props: {
		index: {
			type: Number,
		},
		order: {
			type: Object,
		},
		columns: {
			type: Array,
		},
	},
	data() {
		return {
			isRefunding: false,
			isRestoring: false,
			isRefundingCredit: false,
		};
	},
	methods: {
		validatePhoneNumber,
		showDetails(order, event) {
			this.$emit('detail', order, event);
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this?.user?.timezone ?? 'Asia/Jakarta';
			// const formattedDate = this.moment.utc(dateString).local().format(format);
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		copy(text) {
			copyToClipboard(text);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'copied to clipboard',
			});
		},
		customerDataVariations(val, multiple) {
			return generateVariationsData(val, multiple);
		},
		showShippingTracking(order) {
			return this.$emit('track', order);
		},
		showProduct(order) {
			return this.$emit('showProduct', order);
		},
		getOrderDisplayStatus,
		isShowColumn(key) {
			return this.columns.includes(key);
		},
		getQuantity(order) {
			let quantity = 1;
			if (order.type === 'storefront') {
				quantity = order.cart_items.reduce(
					(total, cartItem) => total + cartItem.qty,
					0,
				);
			} else {
				quantity = order.customer_data.quantity || 1;
				if (order.customer_data.variations) {
					quantity = order.customer_data.variations.reduce(
						(accumulator, variation) => {
							const variationQuantity = variation.quantity || 1;
							return accumulator + variationQuantity;
						},
						0,
					);
				}
			}
			return quantity;
		},
		getCommissionFee(order) {
			const totalCommissionFee = order?.total_commission || 0;
			return this.formatMoney(totalCommissionFee);
		},
		getProductCode(products) {
			let productCodeArray = [];
			if (products.length > 0) {
				productCodeArray = products.map(product => (product.product_code ? product.product_code : '-'));
			}
			return productCodeArray;
		},
		showShippingReturnedAt(order) {
			return order?.shipping?.returned_at ?? '-';
		},
		showDate(date) {
			return date ? this.formatDate(date) : '-';
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			isRoleSuperAdmin: 'isRoleSuperAdmin',
			isRoleFinance: 'isRoleFinance',
		}),
	},
};
</script>

<style scoped>
.vertical-center {
    vertical-align: middle;
}
</style>
